import { Icon, notification } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { isSearchFiltersEmpty } from '@/src/compliance/utils';
import Button from '@/src/shared/components/Button';
import { space } from '@/styles';
import { isAndroid } from '@/utils/detectBrowser';

import style from '../style';
import AddSavedSearch from './AddSavedSearch';

const { m } = space;

const defaultData = {
  SearchId: null,
  SearchDescription: '',
  PersonId: null,
  FieldOptions: {
    Categories: [],
    Charts: [],
    States: [],
    SearchText: '',
    Page: null,
    PageSize: null,
    SortField: null,
    SortOrder: null,
  },
};

const Buttons = ({ form, searchOptions, btnDisabled, handleClear, handleSaveSearch }) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [data, setData] = useState(defaultData);

  useEffect(() => {
    if (!isAndroid()) return;
    if (isModalVisible) {
      document.body.classList.add('is-fixed');
    } else {
      document.body.classList.remove('is-fixed');
    }
  }, [isModalVisible]);

  const handleSave = async () => {
    if (isSearchFiltersEmpty(form)) {
      notification.error({
        message: 'Search',
        description: 'Search option is required.',
      });
      return;
    }
    await form.validateFieldsAndScroll(async (err, values) => {
      if (err) return;
      setData({
        ...data,
        FieldOptions: {
          ...data.FieldOptions,
          ...values,
        },
      });
      setModalVisible(true);
    });
  };

  return (
    <div css={style.footerContainer}>
      <AddSavedSearch
        visible={isModalVisible}
        data={data}
        closeModal={() => setModalVisible(false)}
        searchOptions={searchOptions}
        handleSaveSearch={handleSaveSearch}
      />
      <Button
        disabled={btnDisabled}
        type="button"
        size="small"
        css={[m.r16, m.b16]}
        htmlType="submit"
      >
        Search
      </Button>
      <Button
        disabled={btnDisabled}
        type="button"
        size="small"
        css={[m.r16, m.b16]}
        onClick={handleSave}
      >
        <Icon type="save" theme="filled" /> Save Search
      </Button>
      <Button size="small" theme="gray" css={m.b16} onClick={handleClear} disabled={btnDisabled}>
        <Icon type="sync" /> Reset All
      </Button>
    </div>
  );
};

Buttons.propTypes = {
  form: PropTypes.object.isRequired,
};

export default Buttons;
